import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { Publish, QuizOutlined } from "@mui/icons-material";
import { FruitifyContainer } from "../shared-components/Containers";
import { useAuthenticationStore } from "../stores/auth";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../api";
import StatBox from "../shared-components/StatBox";
import Grid from "@mui/material/Grid";
import { formatWeekDifference, getWeekDiffColor } from "../utils/formatters";
import { withPageTracking } from "../services/postHog";
import { UpcomingAssignmentsAndQuizzes } from "../shared-components/UpcomingAssignmentsAndQuizzes";
import { ProfilePicture } from "./account/components/ProfilePicture";

function DashboardStatBox(props) {
  return <StatBox cardVariant="shadow" {...props} />;
}
export function DashboardStats({ stats }) {
  return (
    <Grid container spacing={4}>
      <Grid size={{ xs: 12, md: 6 }}>
        <DashboardStatBox
          title="Assignments due"
          stat={stats.assignmentsDueStats?.current}
          footer={formatWeekDifference(stats.assignmentsDueStats)}
          footerColor={getWeekDiffColor(stats.assignmentsDueStats)}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <DashboardStatBox
          title="Quizzes due"
          stat={stats.quizzesDueStats?.current}
          footer={formatWeekDifference(stats.quizzesDueStats)}
          footerColor={getWeekDiffColor(stats.quizzesDueStats)}
        />
      </Grid>
    </Grid>
  );
}

const StudentDashboard = () => {
  const { user } = useAuthenticationStore();
  const navigate = useNavigate();
  const [userStats, setUserStats] = useState({});
  const [assignments, setAssignments] = useState([]);
  const [quizzes, setQuizzes] = useState([]);
  const apiClient = useApiClient();
  const roleAssignment = user.info.activeContext?.roleAssignment;

  const fetchUserStats = async () => {
    const data = await apiClient.users.dashboardStats();
    setUserStats(data?.dashboardStats);
    setAssignments(data?.activeRoleData.assignments);
    setQuizzes(data?.activeRoleData.quizzes);
  };
  useEffect(() => {
    fetchUserStats();
  }, []);

  return (
    <FruitifyContainer data-testid={"teacher-dashboard"}>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        gap={2}
        sx={{ mb: 3 }}
      >
        <ProfilePicture editable={false} />

        <Box>
          <Typography variant="h3">
            Welcome back, {user.info.firstName}!
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            {roleAssignment?.school.name}
          </Typography>
        </Box>

        <Box
          display="flex"
          gap={2}
          sx={{
            ml: "auto",
            mt: { xs: 2, sm: 0 },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <Button
            fullWidth={{ xs: true, sm: false }}
            variant="outlined"
            startIcon={<Publish />}
            onClick={() => navigate("/assignments")}
          >
            Upload Answers
          </Button>
          <Button
            fullWidth={{ xs: true, sm: false }}
            variant="outlined"
            startIcon={<QuizOutlined />}
            onClick={() => navigate("/quizzes")}
          >
            Complete Quiz
          </Button>
        </Box>
      </Box>

      <DashboardStats stats={userStats} />
      <UpcomingAssignmentsAndQuizzes
        studentView
        assignments={assignments}
        quizzes={quizzes}
      />
      {/* TODO: if no assignments do we want a quick add button? */}
    </FruitifyContainer>
  );
};

export default withPageTracking(StudentDashboard, {
  feature: "student-dashboard",
});
